function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  "data-name": "Layer 43",
  id: "Layer_43"
}, /*#__PURE__*/React.createElement("path", {
  d: "M29.77,17.62H4a1.5,1.5,0,0,0-1.5,1.5V44.88A1.5,1.5,0,0,0,4,46.38H29.77a1.5,1.5,0,0,0,1.5-1.5V19.12A1.5,1.5,0,0,0,29.77,17.62Zm-1.5,25.76H5.5V20.62H28.27Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M35.77,20.62H60a1.5,1.5,0,0,0,0-3H35.77A1.5,1.5,0,0,0,35.77,20.62Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M35.77,27.06h14a1.5,1.5,0,0,0,0-3h-14A1.5,1.5,0,0,0,35.77,27.06Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M60,30.5H35.77a1.5,1.5,0,0,0,0,3H60A1.5,1.5,0,0,0,60,30.5Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M35.77,39.94h14a1.5,1.5,0,0,0,0-3h-14A1.5,1.5,0,0,0,35.77,39.94Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M60,43.38H35.77a1.5,1.5,0,0,0,0,3H60A1.5,1.5,0,0,0,60,43.38Z"
}));

function SvgCardThumbnail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardThumbnail);
export default __webpack_public_path__ + "static/media/card_thumbnail.c53f523e.svg";
export { ForwardRef as ReactComponent };